const collections = [
  { title: '热播剧集专场', desc: '最新热剧一网打尽，同步各大平台更新', icon: 'ri-fire-line' },
  { title: '院线大片合集', desc: '影院同步大片，高清画质畅快观影', icon: 'ri-film-line' },
  { title: '经典怀旧专场', desc: '重温时代经典，老片修复高清呈现', icon: 'ri-time-line' },
  { title: '日韩剧集精选', desc: '人气日韩剧合集，中字同步更新', icon: 'ri-earth-line' },
  { title: '欧美大片专区', desc: '好莱坞精选，热门美剧英剧全覆盖', icon: 'ri-global-line' },
  { title: '动漫番剧仓库', desc: '热门动漫全收录，国漫日漫一应俱全', icon: 'ri-rocket-line' },
  { title: '综艺娱乐聚合', desc: '热门综艺随时看，笑点不断欢乐不停', icon: 'ri-emotion-happy-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            影视合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型和主题精心分类，快速找到你想看的内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {collections.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-background-200 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 text-center leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}